(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-body"] && !Shopify.designMode) return;
  try {
    (function () {
    function addCaption(img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return;

      var next = img.nextElementSibling;
      if (next && next.classList.contains('article-body__caption')) return;

      var caption = alt;
      var credit = '';
      var creditIdx = alt.indexOf('| Foto:');
      if (creditIdx !== -1) {
        caption = alt.slice(0, creditIdx).trim();
        credit = 'Foto: ' + alt.slice(creditIdx + '| Foto:'.length).trim();
      }
      if (!caption && !credit) return;

      var wrap = document.createElement('span');
      wrap.className = 'article-body__caption';
      if (caption) {
        var captionText = document.createElement('span');
        captionText.className = 'article-body__caption-text';
        captionText.textContent = caption;
        wrap.appendChild(captionText);
      }
      if (credit) {
        var creditText = document.createElement('span');
        creditText.className = 'article-body__caption-credit';
        creditText.textContent = credit;
        wrap.appendChild(creditText);
      }
      img.insertAdjacentElement('afterend', wrap);
    }

    function markOrientation(img) {
      if (img.naturalWidth && img.naturalHeight && img.naturalHeight > img.naturalWidth) {
        img.classList.add('article-body__image--portrait');
      }
    }

    function process(img) {
      if (img.dataset.articleImageProcessed) return;
      img.dataset.articleImageProcessed = 'true';

      addCaption(img);

      if (img.complete && img.naturalWidth) {
        markOrientation(img);
      } else {
        img.addEventListener('load', function () {
          markOrientation(img);
        }, { once: true });
      }
    }

    document.querySelectorAll('.article-body__content img').forEach(process);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["breadcrumb"] && !Shopify.designMode) return;
  try {
    (function () {
    var nav = document.querySelector('.breadcrumb[data-bc-tmpl]');
    if (!nav) return;
    var tmpl = nav.dataset.bcTmpl;

    if (tmpl === 'collection') {
      var handle = nav.dataset.bcCol;
      if (!handle) return;
      var isVendor = nav.dataset.bcIsVendor === 'true';
      var parentTitle = nav.dataset.bcParTitle || null;
      var parentUrl = nav.dataset.bcParUrl || null;
      if (isVendor && !parentTitle) {
        try {
          var prev = JSON.parse(sessionStorage.getItem('bc_ref'));
          if (prev && prev.handle && !prev.isVendor) {
            parentTitle = prev.title;
            parentUrl = prev.url;
          }
        } catch (e) {}
      }
      try {
        sessionStorage.setItem('bc_ref', JSON.stringify({
          handle: handle,
          title: nav.dataset.bcColTitle || handle,
          url: nav.dataset.bcColUrl || '',
          isVendor: isVendor,
          parentTitle: parentTitle,
          parentUrl: parentUrl
        }));
      } catch (e) {}
      return;
    }

    if (tmpl === 'product') {
      var stored;
      try { stored = JSON.parse(sessionStorage.getItem('bc_ref')); } catch (e) {}
      if (!stored || !stored.handle) return;

      var cols = (nav.dataset.bcCols || '').split(',').filter(Boolean);
      if (cols.indexOf(stored.handle) === -1) return;

      var productTitle = nav.dataset.bcProductTitle || '';
      var homeLink = nav.querySelector('a');
      if (!homeLink) return;
      var homeText = homeLink.textContent;
      var homeUrl = homeLink.getAttribute('href');

      while (nav.firstChild) nav.removeChild(nav.firstChild);

      function sep() {
        var s = document.createElement('span');
        s.className = 'breadcrumb__sep';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = '/';
        return s;
      }

      function link(text, href) {
        var a = document.createElement('a');
        a.href = href;
        a.textContent = text;
        return a;
      }

      nav.appendChild(link(homeText, homeUrl));

      var parentTitle = stored.parentTitle;
      var parentUrl = stored.parentUrl;
      if (stored.isVendor && !parentTitle) {
        parentTitle = nav.dataset.bcPrimaryTitle || null;
        parentUrl = nav.dataset.bcPrimaryUrl || null;
      }

      if (parentTitle && parentUrl) {
        nav.appendChild(sep());
        nav.appendChild(link(parentTitle, parentUrl));
      }

      nav.appendChild(sep());
      nav.appendChild(link(stored.title, stored.url));

      nav.appendChild(sep());
      var cur = document.createElement('span');
      cur.setAttribute('aria-current', 'page');
      cur.textContent = productTitle;
      nav.appendChild(cur);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-bundle-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('cart-bundle-modal');
    var pendingConfirm = null;

    document.addEventListener('cart:confirm-bundle-removal', function (e) {
      var onConfirm = e.detail && e.detail.onConfirm;
      if (!onConfirm) return;
      if (!dialog || typeof dialog.showModal !== 'function') {
        onConfirm();
        return;
      }
      pendingConfirm = onConfirm;
      dialog.showModal();
    });

    if (!dialog) return;

    dialog.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bundle-remove-confirm]')) return;
      var cb = pendingConfirm;
      pendingConfirm = null;
      dialog.close();
      if (cb) cb();
    });

    /* Cancelling (close button, Esc, backdrop click) drops the callback. */
    dialog.addEventListener('close', function () {
      pendingConfirm = null;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var panel = drawer.querySelector('.cart-drawer__panel');

    /* ── Open ──────────────────────────────────────────── */
    function openCartDrawer() {
      /* Dismiss any visible cart toast via its close button so the toast's
         own hideToast() runs — clears the auto-dismiss timer and registers
         the transitionend listener in the correct order. */
      var toastCloseBtn = document.querySelector('.cart-toast.is-visible .cart-toast__close');
      if (toastCloseBtn) toastCloseBtn.click();

      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      var backdrop = drawer.querySelector('[data-drawer-backdrop]');
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      syncTriggers(true);
    }

    /* Close is handled by shared drawer-js (backdrop, close btn, Escape). */
    drawer.addEventListener('drawer:close', function () {
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      syncTriggers(false);
    });

    function syncTriggers(isOpen) {
      document.querySelectorAll('[data-cart-open]').forEach(function (el) {
        el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    /* Open when any [data-cart-open] element is clicked. */
    document.addEventListener('click', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var trigger = e.target.closest('[data-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      openCartDrawer();
    });

    /* ── Section Rendering API refresh ─────────────────── */
    function refreshDrawerContents() {
      return fetch('/?sections=cart-drawer-items')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer-items'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBody = doc.getElementById('cart-drawer-body');
          var newFooter = doc.getElementById('cart-drawer-footer');
          var currentBody = document.getElementById('cart-drawer-body');
          var currentFooter = document.getElementById('cart-drawer-footer');
          if (newBody && currentBody) currentBody.replaceWith(newBody);
          if (newFooter) {
            if (currentFooter) {
              currentFooter.replaceWith(newFooter);
            } else if (panel) {
              panel.appendChild(newFooter);
            }
          }
          /* Sync the count badge in the header too. */
          var countEl = document.getElementById('cart-drawer-count');
          if (countEl && newBody) {
            var itemCount = newBody.querySelectorAll('[data-key]').length;
            countEl.textContent = '(' + itemCount + ')';
            countEl.hidden = itemCount === 0;
          }
        });
    }

    /* ── Quantity & Remove ──────────────────────────────── */
    function setLoading(active) {
      drawer.classList.toggle('cart-drawer--loading', active);
    }

    function changeCartItem(key, quantity) {
      setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* Notify other components (header badge, etc.) */
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { count: cart.item_count }
          }));
          return refreshDrawerContents();
        })
        .then(function () { setLoading(false); })
        .catch(function () { setLoading(false); });
    }

    /* ── Bundle cascade removal ─────────────────────────
       Pattern + yarn added together share a _bundle_id line property
       (rendered as data-bundle-id). Removing any line of the bundle
       removes all of them in a single atomic /cart/update.js call. */
    var bundleNote = document.getElementById('cart-drawer-bundle-note');
    var bundleNoteTimer = null;

    function showBundleNote() {
      if (!bundleNote) return;
      bundleNote.hidden = false;
      clearTimeout(bundleNoteTimer);
      bundleNoteTimer = setTimeout(function () {
        bundleNote.hidden = true;
      }, 8000);
    }

    function removeBundle(bundleId) {
      setLoading(true);
      var updates = {};
      drawer.querySelectorAll('[data-key]').forEach(function (el) {
        if (el.dataset.bundleId === bundleId) updates[el.dataset.key] = 0;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { count: cart.item_count }
          }));
          showBundleNote();
          return refreshDrawerContents();
        })
        .then(function () { setLoading(false); })
        .catch(function () { setLoading(false); });
    }

    /* Delegated click handler for qty/remove inside the drawer body. */
    drawer.addEventListener('click', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var item = e.target.closest('[data-key]');
      if (!item) return;

      if (e.target.closest('[data-qty-minus]')) {
        e.preventDefault();
        var qtyEl = item.querySelector('.cart-drawer__qty-val');
        var qty = Math.max(0, parseInt(qtyEl ? qtyEl.textContent : '1', 10) - 1);
        changeCartItem(item.dataset.key, qty);
      } else if (e.target.closest('[data-qty-plus]')) {
        e.preventDefault();
        var qtyEl = item.querySelector('.cart-drawer__qty-val');
        var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) + 1;
        changeCartItem(item.dataset.key, qty);
      } else if (e.target.closest('[data-remove]')) {
        e.preventDefault();
        var bundleId = item.dataset.bundleId;
        if (bundleId) {
          /* Ask for confirmation first — handled by cart-bundle-modal. */
          document.dispatchEvent(new CustomEvent('cart:confirm-bundle-removal', {
            detail: {
              onConfirm: function () { removeBundle(bundleId); }
            }
          }));
        } else {
          changeCartItem(item.dataset.key, 0);
        }
      }
    });

    /* ── Refresh on item added ──────────────────────────── */
    document.addEventListener('cart:item-added', function () {
      refreshDrawerContents();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    var toast = document.getElementById('cart-toast');
    var titleEl = document.getElementById('cart-toast-title');
    var subtitleEl = document.getElementById('cart-toast-subtitle');
    if (!toast) return;

    var dismissTimer = null;

    function positionToast() {
      // Only anchor on non-mobile viewports
      if (window.innerWidth <= 640) return;
      var btn = document.querySelector('.site-header__cart-btn');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      // Align toast's right edge with button's right edge; sit 8px below button
      var rightOffset = window.innerWidth - rect.right;
      toast.style.top = (rect.bottom + 8) + 'px';
      toast.style.right = rightOffset + 'px';
      // Shift arrow to point at button centre
      var arrowRight = Math.round(rect.width / 2) - 5; // half arrow width
      toast.style.setProperty('--arrow-right', arrowRight + 'px');
    }

    function showToast(title, subtitle) {
      if (titleEl) titleEl.textContent = title || '';
      if (subtitleEl) subtitleEl.textContent = subtitle || '';
      positionToast();
      toast.hidden = false;
      // Force a reflow so the transition plays from the start state
      toast.offsetHeight; // eslint-disable-line no-unused-expressions
      toast.classList.add('is-visible');
      clearTimeout(dismissTimer);
      dismissTimer = setTimeout(hideToast, 4000);
    }

    function hideToast() {
      toast.classList.remove('is-visible');
      clearTimeout(dismissTimer);
      toast.addEventListener('transitionend', function handler() {
        toast.hidden = true;
        toast.removeEventListener('transitionend', handler);
      }, { once: true });
    }

    toast.querySelector('.cart-toast__close').addEventListener('click', hideToast);

    // Listen for items being added to cart
    document.addEventListener('cart:item-added', function (e) {
      var detail = e.detail || {};
      showToast(detail.title || '', detail.subtitle || '');
    });

    // Keep cart count badge(s) in sync without a page reload
    document.addEventListener('cart:updated', function (e) {
      var count = (e.detail && e.detail.count) || 0;
      document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      document.querySelectorAll('.site-header__cart-btn').forEach(function (btn) {
        var tpl = btn.dataset.countLabel || '';
        btn.setAttribute('aria-label', tpl.replace('__COUNT__', count));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-sidebar"] && !Shopify.designMode) return;
  try {
    (function () {

    /* ── Subcategory heading above the count ─────────────── */
    /* The vendor name is rendered server-side above the result count
       (collection-layout__count--vendor). Subcategory titles live in the
       category-nav block settings and aren't available to the collection
       section, so we mirror the same heading client-side: when a subcategory
       card is active (and no vendor heading is present — the two are mutually
       exclusive), lift its title above the count. Runs on load and after each
       AJAX re-render. */
    function syncSubcatHeading() {
      var count = document.querySelector('[data-collection-count]');
      if (!count) return;

      // Only act when a subcategory card is active. There's no active card when a
      // brand is selected (the two are mutually exclusive), so this never clobbers
      // the server-rendered vendor heading. When a card IS active it overrides
      // whatever heading the server rendered (e.g. the "all products" label).
      var activeTitle = document.querySelector('.category-nav__card--active .category-nav__card-title');
      if (!activeTitle) return;
      var title = activeTitle.textContent.trim();
      if (!title) return;

      // Reuse the meta span when the server already split out a heading,
      // otherwise the whole count text is the meta line.
      var metaSpan = count.querySelector('.collection-layout__count-meta');
      var meta = metaSpan ? metaSpan.textContent.trim() : count.textContent.trim();

      var heading = document.createElement('span');
      heading.className = 'collection-layout__count-vendor';
      heading.textContent = title;
      var metaEl = document.createElement('span');
      metaEl.className = 'collection-layout__count-meta';
      metaEl.textContent = meta;

      count.classList.add('collection-layout__count--vendor');
      count.replaceChildren(heading, metaEl);
    }

    /* ── AJAX filter navigation ──────────────────────────── */
    var fetchController = null;

    async function collectionNavigateTo(url, push) {
      if (push === undefined) push = true;

      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      var main = document.querySelector('[data-collection-main]');
      var sidebarFilters = document.querySelector('[data-collection-sidebar-filters]');
      var categoryNav = document.querySelector('.category-nav');
      if (main) main.setAttribute('aria-busy', 'true');

      try {
        var res = await fetch(url, { signal: fetchController.signal });
        fetchController = null;
        if (!res.ok) throw new Error('HTTP ' + res.status);

        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newMain = doc.querySelector('[data-collection-main]');
        var newSidebarFilters = doc.querySelector('[data-collection-sidebar-filters]');
        var newCategoryNav = doc.querySelector('.category-nav');

        if (newMain && main) main.replaceWith(newMain);
        if (newSidebarFilters && sidebarFilters) sidebarFilters.replaceWith(newSidebarFilters);
        // Keep the category-nav pills/cards in sync so their active state and
        // toggle URLs reflect the filters just applied.
        if (newCategoryNav && categoryNav) categoryNav.replaceWith(newCategoryNav);

        if (push) history.pushState({ collectionAjax: true }, '', url);
        if (doc.title) document.title = doc.title;

        if (window.CollectionPages) window.CollectionPages.reinit();
        if (window.initCollectionSearch) window.initCollectionSearch();
        syncSubcatHeading();

        window.scrollTo({ top: 0, behavior: 'smooth' });

      } catch (e) {
        if (e.name === 'AbortError') return;
        if (main) main.removeAttribute('aria-busy');
        window.location.href = url;
      }
    }
    window.collectionNavigateTo = collectionNavigateTo;

    /* ── Intercept filter links ──────────────────────────── */
    /* Covers the sidebar facets (when enabled) and the category-nav brand
       pills / subcategory cards, which are the primary filter UI while the
       sidebar is disabled. Only same-collection links are AJAX-navigated;
       links that leave the listing (e.g. the "all brands" pill, or the nav on
       a non-collection page) fall through to a normal navigation. */
    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      var link = e.target.closest('[data-collection-sidebar-filters] a, .category-nav a');
      if (!link || !link.href) return;
      if (!document.querySelector('[data-collection-main]')) return;
      var dest = new URL(link.href, window.location.href);
      if (dest.pathname !== window.location.pathname) return;
      e.preventDefault();
      collectionNavigateTo(link.href);
    });

    /* ── Intercept price form ────────────────────────────── */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-collection-sidebar-filters] .collection-filters__price-form');
      if (!form) return;
      e.preventDefault();
      var url = new URL(form.action || window.location.href);
      new FormData(form).forEach(function (v, k) { url.searchParams.set(k, v); });
      collectionNavigateTo(url.toString());
    });

    /* ── Initial heading sync ────────────────────────────── */
    syncSubcatHeading();

    /* ── Popstate (browser back/forward) ─────────────────── */
    history.replaceState({ collectionAjax: true }, '');
    window.addEventListener('popstate', function (e) {
      if (document.querySelector('[data-collection-main]')) {
        collectionNavigateTo(window.location.href, false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    /* Remove the price range filter — routed through AJAX navigation */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-price-filter-remove]');
    if (!chip) return;
    e.preventDefault();
    var url = new URL(window.location.href);
    var minParam = chip.dataset.minParam;
    var maxParam = chip.dataset.maxParam;
    if (minParam) url.searchParams.delete(minParam);
    if (maxParam) url.searchParams.delete(maxParam);
    if (window.collectionNavigateTo) {
      window.collectionNavigateTo(url.toString());
    } else {
      window.location.href = url.toString();
    }
  });

  /* Collection search: fetches all pages of the search-index and filters
     the product grid, loading additional pages via infinite scroll as needed
     to surface matching products that haven't been rendered yet. */
  (function () {
    var form, input, statusWrap, statusText, resetBtn, grid, countEl;
    var allProducts = null;
    var fetchAllPromise = null;
    var currentQuery = '';
    var INDEX_PAGE_SIZE = 250;

    function buildIndexUrl(page) {
      var params = new URLSearchParams(window.location.search);
      params.set('view', 'search-index');
      params.delete('page');
      if (page > 1) params.set('page', page);
      return window.location.pathname + '?' + params.toString();
    }

    function fetchAllIndexPages() {
      if (fetchAllPromise) return fetchAllPromise;
      var collected = [];

      function fetchPage(page) {
        return fetch(buildIndexUrl(page))
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            if (!data || data.length === 0) return collected;
            collected = collected.concat(data);
            if (data.length < INDEX_PAGE_SIZE) return collected;
            return fetchPage(page + 1);
          });
      }

      fetchAllPromise = fetchPage(1)
        .then(function (data) { allProducts = data; return data; })
        .catch(function () { fetchAllPromise = null; return []; });

      return fetchAllPromise;
    }

    function applyFilterToDom(matchedHandles) {
      var cards = grid ? grid.querySelectorAll('[data-handle]') : [];
      cards.forEach(function (card) {
        card.hidden = !matchedHandles[card.dataset.handle];
      });
    }

    function updateStatus(totalMatches) {
      var total = allProducts ? allProducts.length : 0;
      var noResultsMsg = input ? input.dataset.noResults : '';
      var txt = totalMatches === 0 ? noResultsMsg : totalMatches + ' / ' + total;
      if (statusText) statusText.textContent = txt;
      if (statusWrap) statusWrap.hidden = false;
      if (countEl) countEl.textContent = txt;
    }

    async function applyFilter(query) {
      var q = query.trim().toLowerCase();
      if (!q) { resetFilter(); return; }

      currentQuery = q;
      if (window.CollectionPages) window.CollectionPages.setSearchActive(true);

      await fetchAllIndexPages();
      if (!allProducts || q !== currentQuery) return;

      var matchedHandles = allProducts.filter(function (p) {
        return p.title.toLowerCase().includes(q) ||
          p.vendor.toLowerCase().includes(q) ||
          p.tags.some(function (t) { return t.toLowerCase().includes(q); });
      }).reduce(function (acc, p) { acc[p.handle] = true; return acc; }, {});

      var matchedHandleKeys = Object.keys(matchedHandles);

      updateStatus(matchedHandleKeys.length);
      applyFilterToDom(matchedHandles);

      /* Load more pages until every matched product is in the DOM */
      while (window.CollectionPages && window.CollectionPages.hasMore() && q === currentQuery) {
        var handlesInDom = new Set(
          Array.from(grid.querySelectorAll('[data-handle]')).map(function (c) { return c.dataset.handle; })
        );
        if (matchedHandleKeys.every(function (h) { return handlesInDom.has(h); })) break;

        var loaded = await window.CollectionPages.loadMore();
        if (!loaded || q !== currentQuery) break;

        applyFilterToDom(matchedHandles);
      }
    }

    function resetFilter() {
      currentQuery = '';
      var cards = grid ? grid.querySelectorAll('[data-handle]') : [];
      cards.forEach(function (card) { card.hidden = false; });
      if (countEl) countEl.textContent = countEl.dataset.originalLabel;
      if (statusWrap) statusWrap.hidden = true;
      if (input) input.value = '';
      if (window.CollectionPages) window.CollectionPages.setSearchActive(false);
    }

    function initCollectionSearch() {
      /* Clear stale index cache when filter context changes */
      allProducts = null;
      fetchAllPromise = null;
      currentQuery = '';

      form = document.querySelector('[data-collection-search-form]');
      if (!form) return;
      input = form.querySelector('[data-collection-search-input]');
      statusWrap = document.querySelector('[data-collection-search-status]');
      statusText = statusWrap ? statusWrap.querySelector('[data-collection-search-status-text]') : null;
      resetBtn = statusWrap ? statusWrap.querySelector('[data-collection-search-reset]') : null;
      grid = document.getElementById('product-grid');
      countEl = document.querySelector('[data-collection-count]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilter(input.value);
      });
      if (resetBtn) resetBtn.addEventListener('click', resetFilter);
      if (input) input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') resetFilter();
      });
    }

    window.initCollectionSearch = initCollectionSearch;
    initCollectionSearch();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-load-more"] && !Shopify.designMode) return;
  try {
    (function () {
    var grid, sentinel, loader;
    var loading = false;
    var searchActive = false;
    var observer = null;

    function setupObserver() {
      if (observer) { observer.disconnect(); observer = null; }
      if (!sentinel || !('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !searchActive && !loading) loadNextPage();
      }, { rootMargin: '500px' });
      observer.observe(sentinel);
    }

    function init() {
      if (observer) { observer.disconnect(); observer = null; }
      grid = document.getElementById('product-grid');
      sentinel = document.querySelector('[data-infinite-scroll-sentinel]');
      loader = document.querySelector('[data-infinite-scroll-loader]');
      loading = false;
      if (!grid) return;
      setupObserver();
    }

    function loadNextPage() {
      if (loading || !sentinel) return Promise.resolve(false);
      var url = sentinel.dataset.nextUrl;
      if (!url) return Promise.resolve(false);

      loading = true;
      if (loader) loader.hidden = false;

      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');

          if (newGrid && grid) {
            var fragment = document.createDocumentFragment();
            while (newGrid.firstChild) fragment.appendChild(newGrid.firstChild);
            grid.appendChild(fragment);
          }

          var newSentinel = doc.querySelector('[data-infinite-scroll-sentinel]');
          if (newSentinel && newSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
          } else {
            if (sentinel) { sentinel.remove(); sentinel = null; }
            if (observer) { observer.disconnect(); observer = null; }
          }

          loading = false;
          if (loader) loader.hidden = true;
          window.dispatchEvent(new CustomEvent('collection:page-loaded'));
          return true;
        })
        .catch(function () {
          loading = false;
          if (loader) loader.hidden = true;
          return false;
        });
    }

    window.CollectionPages = {
      loadMore: loadNextPage,
      hasMore: function () { return !!(sentinel && sentinel.dataset.nextUrl); },
      isLoading: function () { return loading; },
      setSearchActive: function (val) { searchActive = val; },
      reinit: init
    };

    init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer-js"] && !Shopify.designMode) return;
  try {
    (function () {
    function openDrawer(drawerEl) {
      drawerEl.classList.add('is-open');
      var backdrop = drawerEl.querySelector('[data-drawer-backdrop]');
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer(drawerEl) {
      drawerEl.classList.remove('is-open');
      var backdrop = drawerEl.querySelector('[data-drawer-backdrop]');
      if (backdrop) backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
      drawerEl.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-drawer-open]');
      if (openBtn) {
        var drawer = openBtn.closest('[data-drawer]');
        if (drawer) { openDrawer(drawer); return; }
      }

      var closeBtn = e.target.closest('[data-drawer-close]');
      if (closeBtn) {
        var drawer = closeBtn.closest('[data-drawer]');
        if (drawer) { closeDrawer(drawer); return; }
      }

      var backdrop = e.target.closest('[data-drawer-backdrop]');
      if (backdrop) {
        var drawer = backdrop.closest('[data-drawer]');
        if (drawer) closeDrawer(drawer);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openDrawers = document.querySelectorAll('[data-drawer].is-open');
      openDrawers.forEach(closeDrawer);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-bars"] && !Shopify.designMode) return;
  try {
    (function () {
    var bottomBar = document.querySelector('.mobile-bar--bottom');
    var topBar = document.querySelector('.mobile-bar--top');

    function onScroll() {
      if (bottomBar) {
        var scrolled = window.scrollY + window.innerHeight;
        var threshold = document.documentElement.scrollHeight - 200;
        bottomBar.classList.toggle('is-visible', scrolled >= threshold);
      }
      if (topBar) {
        topBar.classList.toggle('is-hidden', window.scrollY > 0);
      }
    }

    if (bottomBar || topBar) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-modal-open]');
    if (opener) {
      event.preventDefault();
      var dialog = document.getElementById(opener.getAttribute('data-modal-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else if (dialog) {
        // Fallback for browsers without <dialog> support.
        var href = dialog.getAttribute('data-fallback-href');
        if (href) window.location.href = href;
      }
      return;
    }

    if (event.target.closest('[data-modal-close]')) {
      var openDialog = event.target.closest('dialog');
      if (openDialog) openDialog.close();
      return;
    }

    // Click on the backdrop (the dialog element itself, outside the panel) closes it.
    if (event.target.classList && event.target.classList.contains('modal')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function initForm(form, sid, container) {
      const productDataEl = document.getElementById('product-json-' + sid);
      if (!productDataEl) return;
      const productData = JSON.parse(productDataEl.textContent);

      // Build maps
      const variantsById = {};
      const variantImageMap = {};
      const inventoryByVariantId = {};
      productData.variants.forEach(function (v) {
        variantsById[v.id] = v;
        inventoryByVariantId[v.id] = v.inventory_quantity || 0;
        if (v.featured_image_id) {
          variantImageMap[v.id] = v.featured_image_id;
        }
      });

      // Current state
      let selectedOptions = productData.variants
        .find(function (v) { return v.id === parseInt(container.dataset.currentVariant); })
        ?.options?.slice() || [];

      function findVariant(options) {
        return productData.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        }) || null;
      }

      // Money format template from Shopify (shop.money_with_currency_format), so
      // JS-updated prices match the server-rendered price (price.liquid uses the
      // money_with_currency filter). Mirrors Shopify's own `money` filter logic.
      const moneyFormatEl = document.getElementById('add-to-cart-' + sid);
      const moneyFormat = (moneyFormatEl && moneyFormatEl.dataset.moneyFormat) || '';

      function formatMoney(cents) {
        if (typeof cents === 'string') cents = cents.replace('.', '');

        // Template should always be present; degrade to a grouped integer (no
        // hardcoded currency) if it is ever missing.
        if (!moneyFormat) return Math.round(cents / 100).toLocaleString('sv-SE');

        const placeholder = /\{\{\s*(\w+)\s*\}\}/;

        function withDelimiters(number, precision, thousands, decimal) {
          precision = typeof precision === 'undefined' ? 2 : precision;
          thousands = typeof thousands === 'undefined' ? ',' : thousands;
          decimal = typeof decimal === 'undefined' ? '.' : decimal;

          if (isNaN(number) || number == null) return '0';

          number = (number / 100.0).toFixed(precision);
          const parts = number.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          const centsPart = parts[1] ? decimal + parts[1] : '';
          return dollars + centsPart;
        }

        const match = moneyFormat.match(placeholder);
        if (!match) return moneyFormat;

        let value = '';
        switch (match[1]) {
          case 'amount':
            value = withDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = withDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = withDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = withDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = withDelimiters(cents, 2, "'", '.');
            break;
          case 'amount_with_space_separator':
            value = withDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = withDelimiters(cents, 0, ' ', '');
            break;
          default:
            value = withDelimiters(cents, 2);
        }

        return moneyFormat.replace(placeholder, value);
      }

      const atcBtn = document.getElementById('add-to-cart-' + sid);
      const atcPrice = document.getElementById('atc-price-' + sid);
      const qtyInput = document.getElementById('quantity-' + sid);

      function updateAtcPrice() {
        if (!atcBtn || !atcPrice) return;
        const unitPrice = parseInt(atcBtn.dataset.unitPrice, 10) || 0;
        const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        atcPrice.textContent = formatMoney(unitPrice * qty);
      }

      function applyVariant(variant) {
        if (!variant) return;

        // Compute inventory quantity and backorder state
        const variantQty = inventoryByVariantId[variant.id] || 0;
        const isBackorder = variant.available && !!variant.inventory_management && variantQty <= 0;

        // Update hidden ID input
        const idInput = document.getElementById('variant-id-' + sid);
        if (idInput) idInput.value = variant.id;

        // Update ATC button
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.classList.toggle('product-form__atc--soldout', !variant.available);
          atcBtn.classList.toggle('product-form__atc--backorder', isBackorder);
          atcBtn.dataset.unitPrice = variant.price;
          if (atcPrice) atcPrice.hidden = !variant.available;

          let dot = atcBtn.querySelector('.product-form__atc-soldout-dot');
          if (!variant.available) {
            if (!dot) {
              dot = document.createElement('span');
              dot.className = 'product-form__atc-soldout-dot';
              dot.setAttribute('aria-hidden', 'true');
              atcBtn.insertBefore(dot, atcBtn.querySelector('svg').nextSibling);
            }
          } else if (dot) {
            dot.remove();
          }

          const label = document.getElementById('atc-label-' + sid);
          if (label) {
            if (variant.available) label.textContent = atcBtn.dataset.labelAdd || '';
            else if (variant.discontinued) label.textContent = atcBtn.dataset.labelDiscontinued || '';
            else label.textContent = atcBtn.dataset.labelSold || '';
          }
        }
        updateAtcPrice();

        // Toggle backorder notice
        const backorderEl = document.getElementById('product-backorder-' + sid);
        if (backorderEl) backorderEl.hidden = !isBackorder;

        // Toggle discontinued notice
        const isDiscontinued = !!variant.discontinued;
        const discontinuedEl = document.getElementById('product-discontinued-' + sid);
        if (discontinuedEl) {
          discontinuedEl.hidden = !isDiscontinued;
          discontinuedEl.classList.toggle('product__discontinued--gone', !variant.available);
          discontinuedEl.textContent = variant.available
            ? (discontinuedEl.dataset.labelSelling || '')
            : (discontinuedEl.dataset.labelGone || '');
        }

        // Swap in the colour's own note (custom.note), pre-rendered per variant
        const noteEl = document.getElementById('product-variant-note-' + sid);
        if (noteEl) {
          const noteTpl = document.getElementById('product-variant-note-' + sid + '-' + variant.id);
          noteEl.innerHTML = noteTpl ? noteTpl.innerHTML : '';
          noteEl.hidden = !noteTpl;
        }

        // Update price
        const priceWrap = document.getElementById('product-price-' + sid);
        if (priceWrap) {
          const comparePrice = variant.compare_at_price;
          const price = variant.price;
          let html = '';
          if (comparePrice && comparePrice > price) {
            html = '<div class="price price--sale">'
              + '<span class="price__current">' + formatMoney(price) + '</span>'
              + '<s class="price__compare">' + formatMoney(comparePrice) + '</s>'
              + '</div>';
          } else if (price === 0 && priceWrap.dataset.freeLabel) {
            const free = document.createElement('span');
            free.className = 'price__current price__current--free';
            free.textContent = priceWrap.dataset.freeLabel;
            html = '<div class="price">' + free.outerHTML + '</div>';
          } else {
            html = '<div class="price"><span class="price__current">' + formatMoney(price) + '</span></div>';
          }
          priceWrap.innerHTML = html;
        }

        // Update inventory
        const invEl = document.getElementById('product-inventory-' + sid);
        if (invEl) {
          const qty = variantQty;
          const threshold = parseInt(invEl.dataset.lowStockThreshold, 10) || 0;
          if (!variant.available) {
            // A discontinued colour's own notice says it's gone for good
            invEl.textContent = isDiscontinued ? '' : (invEl.dataset.soldOut || '');
            invEl.classList.remove('product__inventory--low');
            invEl.classList.add('product__inventory--soldout');
          } else if (variant.inventory_management && qty > 0) {
            const isLow = threshold > 0 && qty <= threshold;
            invEl.classList.toggle('product__inventory--low', isLow);
            invEl.classList.remove('product__inventory--soldout');
            invEl.textContent = isLow ? (invEl.dataset.lowStock || '') : (invEl.dataset.inStock || '');
          } else {
            invEl.textContent = '';
            invEl.classList.remove('product__inventory--low');
            invEl.classList.remove('product__inventory--soldout');
          }
        }

        // Update URL
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ variantId: variant.id }, '', url.toString());
        }

        // Notify gallery and other listeners
        container.dispatchEvent(new CustomEvent('product:variant-changed', {
          bubbles: true,
          detail: {
            variant: variant,
            imageId: variantImageMap[variant.id] ?? null
          }
        }));
      }

      function selectOptionValue(optionIndex, value) {
        selectedOptions[optionIndex] = value;

        // Try exact match first
        let variant = findVariant(selectedOptions);

        // Fall back: find any available variant with the selected option
        if (!variant) {
          variant = productData.variants.find(function (v) {
            return v.options[optionIndex] === value && v.available;
          }) || productData.variants.find(function (v) {
            return v.options[optionIndex] === value;
          });
          if (variant) selectedOptions = variant.options.slice();
        }

        if (!variant) return;

        // Update color name label
        const colorLabel = document.getElementById('selected-color-' + sid + '-' + optionIndex);
        if (colorLabel) {
          const base = value.replace(/\./g, colorLabel.dataset.decimalSeparator || ',');
          const discontinuedLabel = variant.available
            ? (colorLabel.dataset.discontinuedLabel || '')
            : (colorLabel.dataset.discontinuedGoneLabel || '');
          colorLabel.textContent = variant.discontinued && discontinuedLabel ? base + ' ' + discontinuedLabel : base;
        }

        // Update swatch active states
        const swatches = container.querySelectorAll('.product-swatch[data-option-index="' + optionIndex + '"]');
        swatches.forEach(function (sw) {
          const isActive = sw.dataset.value === value;
          sw.classList.toggle('is-active', isActive);
          sw.setAttribute('aria-pressed', isActive.toString());
        });

        applyVariant(variant);
      }

      // Centre the selected swatch in its panel on load (e.g. arriving via ?variant=).
      // Scrolls only the panel, never the page; runs before lazy-load and the
      // chevrons so both see the final scroll position.
      container.querySelectorAll('[data-swatch-scroll]').forEach(function (scrollEl) {
        const active = scrollEl.querySelector('.product-swatch.is-active');
        if (!active) return;
        const panel = scrollEl.getBoundingClientRect();
        const sw = active.getBoundingClientRect();
        scrollEl.scrollTop += (sw.top - panel.top) - (panel.height - sw.height) / 2;
        scrollEl.scrollLeft += (sw.left - panel.left) - (panel.width - sw.width) / 2;
      });

      // Swatch lazy-load: swap data-src → src as swatches enter the scroll container
      container.querySelectorAll('[data-swatch-scroll]').forEach(function (scrollEl) {
        const lazyImgs = scrollEl.querySelectorAll('img[data-src]');
        if (!lazyImgs.length) return;
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const img = entry.target;
            const done = function () {
              img.removeAttribute('data-src');
              img.classList.add('is-loaded');
            };
            if (img.complete && img.naturalWidth > 0) {
              done();
            } else {
              img.addEventListener('load', done, { once: true });
              img.addEventListener('error', done, { once: true });
            }
            img.src = img.dataset.src;
            observer.unobserve(img);
          });
        }, { root: scrollEl, rootMargin: '100px 100px 100px 100px', threshold: 0 });
        lazyImgs.forEach(function (img) { observer.observe(img); });
      });

      // Swatch scroll chevrons (mobile)
      container.querySelectorAll('[data-swatch-scroll]').forEach(function (scrollEl) {
        var wrap = scrollEl.parentElement;
        var btnPrev = wrap.querySelector('.product-option__swatch-chevron--prev');
        var btnNext = wrap.querySelector('.product-option__swatch-chevron--next');
        if (!btnPrev || !btnNext) return;

        function updateSwatchChevrons() {
          var atStart = scrollEl.scrollLeft <= 4;
          var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 4;
          btnPrev.hidden = atStart;
          btnNext.hidden = atEnd;
        }

        scrollEl.addEventListener('scroll', updateSwatchChevrons, { passive: true });
        window.addEventListener('resize', updateSwatchChevrons);
        updateSwatchChevrons();

        function swatchScrollAmount() {
          var item = scrollEl.querySelector('.product-swatch');
          return item ? (item.offsetWidth + 4) * 3 : 204; // 3 swatches
        }

        btnPrev.addEventListener('click', function () {
          scrollEl.scrollBy({ left: -swatchScrollAmount(), behavior: 'smooth' });
        });
        btnNext.addEventListener('click', function () {
          scrollEl.scrollBy({ left: swatchScrollAmount(), behavior: 'smooth' });
        });
      });

      // Swatch search + stock filter
      container.querySelectorAll('[data-swatch-search]').forEach(function (input) {
        const optionDiv = input.closest('.product-option');
        const scrollEl = optionDiv ? optionDiv.querySelector('[data-swatch-scroll]') : null;
        if (!scrollEl) return;
        const stockCheckbox = optionDiv ? optionDiv.querySelector('[data-swatch-filter-instock]') : null;

        function applySwatchFilter() {
          const q = input.value.trim().toLowerCase();
          const onlyInStock = stockCheckbox && stockCheckbox.checked;
          scrollEl.querySelectorAll('.product-swatch').forEach(function (sw) {
            const matchesSearch = !q || (sw.dataset.value || '').toLowerCase().includes(q);
            const matchesStock = !onlyInStock || (!sw.classList.contains('is-unavailable') && !sw.classList.contains('has-backorder'));
            sw.hidden = !(matchesSearch && matchesStock);
          });
        }

        input.addEventListener('input', applySwatchFilter);
        if (stockCheckbox) stockCheckbox.addEventListener('change', applySwatchFilter);
      });

      // Swatch clicks
      container.addEventListener('click', function (e) {
        const swatch = e.target.closest('.product-swatch');
        if (!swatch) return;
        const optIdx = parseInt(swatch.dataset.optionIndex);
        const value = swatch.dataset.value;
        selectOptionValue(optIdx, value);
      });

      // Select changes
      container.addEventListener('change', function (e) {
        const select = e.target.closest('.product-option__select');
        if (!select) return;
        const optIdx = parseInt(select.dataset.optionIndex);
        selectOptionValue(optIdx, select.value);
      });

      // Quantity stepper
      container.addEventListener('click', function (e) {
        const btn = e.target.closest('.product-form__qty-btn');
        if (!btn || !qtyInput) return;
        const action = btn.dataset.qtyAction;
        const current = parseInt(qtyInput.value) || 1;
        if (action === 'inc') {
          qtyInput.value = current + 1;
        } else if (action === 'dec' && current > 1) {
          qtyInput.value = current - 1;
        }
        updateAtcPrice();
      });
      if (qtyInput) {
        qtyInput.addEventListener('input', updateAtcPrice);
        qtyInput.addEventListener('change', updateAtcPrice);
      }

      // AJAX add-to-cart — prevents redirect to /cart
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn && atcBtn.disabled) return;

        // Show loading state
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.classList.add('product-form__atc--loading');
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (data) { throw data; });
            return res.json();
          })
          .then(function (item) {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.classList.remove('product-form__atc--loading');
            }
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: {
                title: item.product_title,
                subtitle: item.variant_title || '',
                quantity: item.quantity
              }
            }));
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (res) { return res.json(); })
          .then(function (cartData) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { count: cartData.item_count }
            }));
          })
          .catch(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.classList.remove('product-form__atc--loading');
            }
          });
      });
    }

    document.querySelectorAll('.product-form').forEach(function (form) {
      const container = form.closest('.product[data-section]');
      if (!container) return;
      initForm(form, container.dataset.section, container);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(sid) {
      const container = document.getElementById('product-' + sid);
      if (!container) return;

      const colorOptionIndex = parseInt(container.dataset.colorOptionIndex || '-1');

      // ── Hoisted no-op; reassigned by initPhotoStrip when chevrons exist ──
      let updatePhotosChevrons = function () {};

      // ── Gallery ───────────────────────────────────────────────────────────

      function activateSlideByIndex(index) {
        const slides = document.querySelectorAll('#product-slides-' + sid + ' .product__slide');
        const photoCards = document.querySelectorAll('#product-photos-' + sid + ' .product__photo-card');
        let activeImageId = null;
        slides.forEach(function (s, i) {
          const isActive = i === index;
          s.classList.toggle('is-active', isActive);
          if (isActive) activeImageId = s.dataset.imageId;
        });
        let activeCard = null;
        photoCards.forEach(function (c) {
          const isActive = activeImageId !== null && c.dataset.imageId === activeImageId;
          c.classList.toggle('is-active', isActive);
          if (isActive) activeCard = c;
        });
        if (activeCard) scrollCardIntoView(activeCard);

        const activeSlide = slides[index];
        const creditEl = document.getElementById('product-credit-' + sid);
        if (creditEl) {
          creditEl.textContent = activeSlide ? (activeSlide.dataset.photoCredit || '') : '';
        }
        const captionVariantEl = document.getElementById('product-caption-variant-' + sid);
        if (captionVariantEl) {
          captionVariantEl.textContent = activeSlide ? (activeSlide.dataset.caption || '') : '';
        }
      }

      function showImageById(imageId) {
        const slides = document.querySelectorAll('#product-slides-' + sid + ' .product__slide');
        slides.forEach(function (s, i) {
          if (parseInt(s.dataset.imageId) === imageId) activateSlideByIndex(i);
        });
      }

      // ── Color gallery loader (Section Rendering API) ──────────────────────
      //
      // The server only renders slides + photo cards for the currently active
      // color. Switching color fetches the section markup for a variant of the
      // target color and replaces the gallery innerHTML. Results are cached
      // per-color so going back to a previously viewed color is instant.

      const galleryCache = new Map();
      const mainView = container.querySelector('.product__main-view');
      const initialColor = (mainView && mainView.dataset.activeColor) || '';
      let currentColor = initialColor;
      let loadToken = 0;

      // Pre-cache the server-rendered initial state
      (function cacheInitial() {
        const slidesEl = document.getElementById('product-slides-' + sid);
        const photosEl = document.getElementById('product-photos-' + sid);
        if (!slidesEl) return;
        galleryCache.set(initialColor, {
          slidesHTML: slidesEl.innerHTML,
          photosHTML: photosEl ? photosEl.innerHTML : ''
        });
      })();

      function pickVariantIdForColor(colorValue) {
        const sel = '.product-swatch[data-value="' + (window.CSS && CSS.escape ? CSS.escape(colorValue) : colorValue.replace(/"/g, '\\"')) + '"]';
        const sw = container.querySelector(sel);
        return sw ? sw.dataset.variantId : null;
      }

      function applyGallery(cached) {
        const slidesEl = document.getElementById('product-slides-' + sid);
        const photosEl = document.getElementById('product-photos-' + sid);
        if (slidesEl) slidesEl.innerHTML = cached.slidesHTML;
        if (photosEl && cached.photosHTML !== undefined) photosEl.innerHTML = cached.photosHTML;
        activateSlideByIndex(0);
        updatePhotosChevrons();
      }

      async function loadColorGallery(colorValue) {
        const myToken = ++loadToken;
        const cached = galleryCache.get(colorValue);
        if (cached) {
          applyGallery(cached);
          return;
        }
        const variantId = pickVariantIdForColor(colorValue);
        if (!variantId) return;
        try {
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('variant', variantId);
          url.searchParams.set('section_id', sid);
          const res = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!res.ok) return;
          const html = await res.text();
          if (myToken !== loadToken) return; // a newer request superseded this one
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newSlides = doc.getElementById('product-slides-' + sid);
          const newPhotos = doc.getElementById('product-photos-' + sid);
          if (!newSlides) return;
          const entry = {
            slidesHTML: newSlides.innerHTML,
            photosHTML: newPhotos ? newPhotos.innerHTML : ''
          };
          galleryCache.set(colorValue, entry);
          applyGallery(entry);
        } catch (e) {
          /* swallow — gallery stays as-is on network failure */
        }
      }

      // ── Photo strip ───────────────────────────────────────────────────────

      function scrollCardIntoView(card) {
        const photosGrid = document.getElementById('product-photos-' + sid);
        if (!card || !photosGrid) return;
        const cRect = photosGrid.getBoundingClientRect();
        const kRect = card.getBoundingClientRect();
        const cardLeft  = photosGrid.scrollLeft + (kRect.left - cRect.left);
        const cardRight = cardLeft + card.offsetWidth;
        const visLeft   = photosGrid.scrollLeft;
        const visRight  = visLeft + photosGrid.clientWidth;
        if (cardLeft < visLeft) {
          photosGrid.scrollTo({ left: cardLeft, behavior: 'smooth' });
        } else if (cardRight > visRight) {
          photosGrid.scrollTo({ left: cardRight - photosGrid.clientWidth, behavior: 'smooth' });
        }
      }

      function initPhotoStrip() {
        const photosGrid = document.getElementById('product-photos-' + sid);
        const photosArea = document.getElementById('product-photos-area-' + sid);
        if (!photosGrid) return;

        const chevPrev = photosArea && photosArea.querySelector('.product__photos-chevron--prev');
        const chevNext = photosArea && photosArea.querySelector('.product__photos-chevron--next');
        if (chevPrev && chevNext) {
          updatePhotosChevrons = function () {
            chevPrev.hidden = photosGrid.scrollLeft <= 4;
            chevNext.hidden = photosGrid.scrollLeft + photosGrid.clientWidth >= photosGrid.scrollWidth - 4;
          };
          photosGrid.addEventListener('scroll', updatePhotosChevrons, { passive: true });
          window.addEventListener('resize', updatePhotosChevrons);
          updatePhotosChevrons();

          function scrollByCard(dir) {
            const card = photosGrid.querySelector('.product__photo-card');
            photosGrid.scrollBy({ left: dir * (card ? card.offsetWidth + 8 : 120), behavior: 'smooth' });
          }
          chevPrev.addEventListener('click', function () { scrollByCard(-1); });
          chevNext.addEventListener('click', function () { scrollByCard(1); });
        }

        photosGrid.addEventListener('click', function (e) {
          const card = e.target.closest('.product__photo-card');
          if (!card) return;
          scrollCardIntoView(card);
          showImageById(parseInt(card.dataset.imageId));
          container.querySelector('.product__main-view')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }

      // ── Touch swipe ───────────────────────────────────────────────────────

      function initSwipe() {
        const mainView = container.querySelector('.product__main-view');
        if (!mainView) return;
        let touchStartX = 0;
        let touchStartY = 0;
        mainView.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        mainView.addEventListener('touchend', function (e) {
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          const cards = Array.from(document.querySelectorAll('#product-photos-' + sid + ' .product__photo-card'));
          const activeIdx = cards.findIndex(function (c) { return c.classList.contains('is-active'); });
          if (activeIdx === -1) return;
          var targetCard = null;
          if (dx < 0 && activeIdx < cards.length - 1) {
            targetCard = cards[activeIdx + 1];
          } else if (dx > 0 && activeIdx > 0) {
            targetCard = cards[activeIdx - 1];
          }
          if (targetCard) {
            showImageById(parseInt(targetCard.dataset.imageId));
            scrollCardIntoView(targetCard);
          }
        }, { passive: true });
      }

      // ── Variant change event ──────────────────────────────────────────────

      function initVariantListener() {
        container.addEventListener('product:variant-changed', function (e) {
          const { variant, imageId } = e.detail;
          if (colorOptionIndex >= 0 && variant.options[colorOptionIndex]) {
            const newColor = variant.options[colorOptionIndex];
            if (newColor !== currentColor) {
              currentColor = newColor;
              loadColorGallery(newColor);
              return;
            }
          }
          if (imageId) showImageById(imageId);
        });
      }

      // ── Bootstrap ─────────────────────────────────────────────────────────

      initPhotoStrip();
      initSwipe();
      initVariantListener();

      // Sync the active thumbnail + caption to the server-rendered active slide
      // so the first thumb isn't left semi-transparent on initial load.
      const initialSlides = document.querySelectorAll('#product-slides-' + sid + ' .product__slide');
      let initialIndex = 0;
      initialSlides.forEach(function (s, i) {
        if (s.classList.contains('is-active')) initialIndex = i;
      });
      activateSlideByIndex(initialIndex);
    }

    document.querySelectorAll('.product[data-section]').forEach(function (el) {
      init(el.dataset.section);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-progress"] && !Shopify.designMode) return;
  try {
    (function () {
    // Mirror of Shopify's `money` Liquid filter so JS-rendered amounts match the
    // store's Money format setting exactly (decimals / separators / currency text).
    // `format` is Shopify's money_with_currency_format template; `currency` is the
    // cart's active ISO code, used only as a fallback if the template is missing.
    function formatMoney(cents, format, currency) {
      if (typeof cents === 'string') cents = cents.replace('.', '');

      // No template available: let the browser format using the active currency.
      if (!format) {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'XXX'
        }).format(cents / 100);
      }

      var placeholder = /\{\{\s*(\w+)\s*\}\}/;

      function withDelimiters(number, precision, thousands, decimal) {
        precision = typeof precision === 'undefined' ? 2 : precision;
        thousands = typeof thousands === 'undefined' ? ',' : thousands;
        decimal = typeof decimal === 'undefined' ? '.' : decimal;

        if (isNaN(number) || number == null) return '0';

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      var match = format.match(placeholder);
      if (!match) return format;

      var value = '';
      switch (match[1]) {
        case 'amount':
          value = withDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', '');
          break;
        default:
          value = withDelimiters(cents, 2);
      }

      return format.replace(placeholder, value);
    }

    document.querySelectorAll('[data-shipping-progress]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      if (threshold <= 0) return;

      // Money format template from Shopify (shop.money_with_currency_format).
      // Empty only in the unlikely case the attribute is missing — handled below.
      var moneyFormat = el.dataset.moneyFormat || '';

      var label = el.querySelector('[data-shipping-label]');
      var fill = el.querySelector('.shipping-card__fill');
      var track = el.querySelector('.shipping-card__track');
      var fee = el.querySelector('[data-shipping-fee]');

      function render(cart) {
        // Hidden until the cart holds at least one item
        if (!cart.item_count) {
          el.hidden = true;
          return;
        }
        el.hidden = false;

        var total = cart.total_price;
        var pct = Math.min(100, Math.round((total * 100) / threshold));
        el.style.setProperty('--pct', pct + '%');
        if (track) track.setAttribute('aria-valuenow', pct);

        if (total >= threshold) {
          el.classList.add('shipping-card--unlocked');
          if (label) label.textContent = el.dataset.msgUnlocked || '';
          if (fee) fee.hidden = true;
        } else {
          el.classList.remove('shipping-card--unlocked');
          if (label) {
            label.textContent = (el.dataset.msgRemaining || '').replace('__AMT__', formatMoney(threshold - total, moneyFormat, cart.currency));
          }
          if (fee) fee.hidden = false;
        }
      }

      document.addEventListener('cart:updated', function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { render(cart); })
          .catch(function () {});
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["special-colours"] && !Shopify.designMode) return;
  try {
    // Pick the colour in place instead of reloading: click its swatch (or set the
  // colour dropdown), then bring the colour picker into view.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-special-variant-id]');
    if (!link) return;
    var id = link.dataset.specialVariantId;
    var swatch = document.querySelector('.product-swatch[data-variant-id="' + id + '"]');
    if (!swatch) return; // no swatches on this page: follow the ?variant= link
    e.preventDefault();
    swatch.click();
    var option = swatch.closest('.product-option') || swatch;
    option.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var panel = swatch.closest('[data-swatch-scroll]');
    if (panel) {
      var p = panel.getBoundingClientRect();
      var s = swatch.getBoundingClientRect();
      panel.scrollTop += (s.top - p.top) - (p.height - s.height) / 2;
      panel.scrollLeft += (s.left - p.left) - (p.width - s.width) / 2;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
    var tip = document.createElement('div');
    tip.className = 'theme-tooltip';
    tip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tip);

    var hideTimer = null;

    function showTip(el) {
      clearTimeout(hideTimer);
      var text = el.getAttribute('data-tooltip');
      if (!text) return;
      tip.textContent = text;
      tip.classList.add('is-visible');
      positionTip(el);
    }

    function positionTip(el) {
      var rect = el.getBoundingClientRect();
      var tipW = tip.offsetWidth;
      var tipH = tip.offsetHeight;
      var margin = 8;
      // Prefer above; fall back to below if not enough space
      var top = rect.top - tipH - 8;
      if (top < margin) top = rect.bottom + 8;
      // Center horizontally, clamped to viewport
      var left = rect.left + rect.width / 2 - tipW / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - tipW - margin));
      tip.style.top = top + 'px';
      tip.style.left = left + 'px';
    }

    function hideTip(delay) {
      clearTimeout(hideTimer);
      if (delay) {
        hideTimer = setTimeout(function () { tip.classList.remove('is-visible'); }, delay);
      } else {
        tip.classList.remove('is-visible');
      }
    }

    // e.target can be a non-Element node (text node, document) during
    // capture-phase mouse events, where .closest is undefined.
    function closestTooltip(target) {
      if (!(target instanceof Element)) return null;
      return target.closest('[data-tooltip]');
    }

    // Desktop: hover
    document.addEventListener('mouseenter', function (e) {
      var el = closestTooltip(e.target);
      if (!el) return;
      showTip(el);
    }, true);

    document.addEventListener('mouseleave', function (e) {
      var el = closestTooltip(e.target);
      if (!el) return;
      hideTip(0);
    }, true);

    // Mobile: tap — show briefly, then auto-dismiss
    var touchStartX = 0;
    var touchStartY = 0;

    document.addEventListener('touchstart', function (e) {
      var el = closestTooltip(e.target);
      var t = e.touches[0];
      touchStartX = t ? t.clientX : 0;
      touchStartY = t ? t.clientY : 0;
      if (!el) return;
      showTip(el);
      hideTip(1500);
    }, { passive: true });

    // Hide when the touch moves — it's a scroll gesture, tooltip position goes stale
    document.addEventListener('touchmove', function (e) {
      if (!tip.classList.contains('is-visible')) return;
      var t = e.touches[0];
      if (!t) { hideTip(0); return; }
      var dx = Math.abs(t.clientX - touchStartX);
      var dy = Math.abs(t.clientY - touchStartY);
      if (dx > 4 || dy > 4) hideTip(0);
    }, { passive: true });

    // Also hide on page scroll (e.g. main page scroll on desktop)
    window.addEventListener('scroll', function () { hideTip(0); }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
